import { memo } from "react";
import { Canvas } from "@react-three/fiber";
import { DEFAULT_CONFIG } from "renderer/config/default";
import { Stage } from "renderer/components/Stage";
import merge from "rtUtils/merge";
import { VIEWER_MODES } from "../../consts";
import ConfigControls, { Controls } from "../Controls";
import Screenshot from "../Screenshot";
import { getDeepCompare } from "../../utils";

const MemoizedCanvas = memo(({
	                             modelUrl,
	                             zoomDirection,
	                             setProgress,
	                             takeScreenshot,
	                             onModelReady,
	                             modelContent,
	                             panRotate,
	                             rendererConfig,
	                             mode,
	                             modelEventsManager,
	                             children,
                             }) => {
	const config = merge(
	{},
		DEFAULT_CONFIG,
		rendererConfig,
		{
			model: {
				url: modelUrl,
				dontScale: mode === VIEWER_MODES.QR,
			},
			debug: {...DEFAULT_CONFIG.debug, ...rendererConfig.debug, orbitControls: false},
		}
	);

	const cursor = panRotate ? "pointer" : "default";

	return (
		<Canvas shadows style={{ cursor }}>
			<Stage
				{...config}
				onModelLoadProgress={setProgress}
				onModelReady={onModelReady}
				modelContent={modelContent}
				onModelClick={modelEventsManager.onClick}
				onModelPointerOver={modelEventsManager.onPointerOver}
				onModelPointerOut={modelEventsManager.onPointerOut}
			>
				{children}
			</Stage>
			{
				mode === VIEWER_MODES.QR ?
					<Controls zoomDirection={zoomDirection} rotateEnabled={true} offOnInteraction={true}/> :
					<ConfigControls zoomDirection={zoomDirection}/>
			}
			{takeScreenshot && <Screenshot/>}
		</Canvas>
	);
}, getDeepCompare(2));

export default MemoizedCanvas;
